
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { UiTextbox } from '../keen-ui'
import { EpbBadge } from '../shared/epb-badge'

export default defineComponent({
  name: 'SearchInput',
  components: {
    EpbBadge,
    UiTextbox,
  },
  props: {
    label: String,
    help: String,
    query: String,
    suggestedKeywords: Array as PropType<Array<string>>,
    textboxVisible: Boolean,
    keywordsMultipleSelection: Boolean,
  },
  data() {
    return {
      searchInputValue: '',
    }
  },
  computed: {
    selectedKeywords(): string {
      return this.searchInputValue
        .split(',')
        .filter((value: string) => this.suggestedKeywords.includes(value))
    },
  },
  watch: {
    suggestedKeywords(newValues: string[]) {
      if (this.suggestedKeywords) {
        this.toggleSelectedKeyword(newValues[newValues.length - 1])
      }
    },
  },
  created() {
    if (this.suggestedKeywords) {
      this.toggleSelectedKeyword(this.suggestedKeywords[0])
    }
  },
  methods: {
    onQueryChange(): void {
      const inputEl: HTMLInputElement = this.$refs.searchbox.$refs.input as HTMLInputElement
      this.$emit('queryChange', inputEl.value)
    },
    toggleSelectedKeyword(keyword: string): void {
      const queryList = this.searchInputValue.split(',')
      if (!this.isSelectedKeyword(keyword)) {
        if (queryList[0] === '' || !this.keywordsMultipleSelection) {
          queryList[0] = keyword
        } else {
          queryList.push(keyword)
        }
      }
      this.searchInputValue = queryList.join()
      this.$emit('queryChange', this.searchInputValue)
    },
    isSelectedKeyword(keyword: string): boolean {
      return this.selectedKeywords.includes(keyword)
    },
  },
})
